module.exports = __webpack_public_path__ + "img/saved.45fbc88e.jpg";